(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/collections/best-rows-match-list.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/collections/best-rows-match-list.js'); 'use strict';

svs.sport.best_rows.collections.BestRowsMatchList = Backbone.Collection.extend({
  model: svs.sport.best_rows.models.BestRowsMatchListItem,
  setMode: function setMode(data) {
    this.models.forEach(function (model) {
      model.set(data, {
        silent: true
      });
    });
    this.trigger('modeChange', data);
  },
  update: function update(_update) {
    var self = this;

    if (_update.get('eventNumber') && this.at(_update.get('eventNumber') - 1)) {
      this.at(_update.get('eventNumber') - 1).set({
        homeTeamGoals: _update.get('homeTeamGoals'),
        awayTeamGoals: _update.get('awayTeamGoals'),
        outcome: _update.get('outcome') ? _update.get('outcome') : self.getOutcome(_update.get('homeTeamGoals'), _update.get('awayTeamGoals'), _update),
        hasMatchStarted: _update.get('hasMatchStarted'),
        drawClosed: _update.get('drawClosed'),
        cancelled: _update.get('cancelled'),
        forecastVerified: _update.get('forecastVerified')
      });
    }
  },
  getOutcome: function getOutcome(homeGoals, awayGoals, update) {
    if (update.get('betResult')) {
      return update.get('betResult').outcome;
    }

    if (homeGoals > awayGoals) {
      return '1';
    } else if (awayGoals > homeGoals) {
      return '2';
    }

    return 'X';
  }
});
 })(window);